import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=fd9fdb42&scoped=true&"
import script from "./MobilePage.vue?vue&type=script&lang=js&"
export * from "./MobilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9fdb42",
  null
  
)

export default component.exports